import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, Chip, FormControlLabel, IconButton, Paper, TextField, Typography, } from "@material-ui/core";
import { ExpandMore, Image } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { ReOrderPlaylistTracksTable, usePlaylistDuration, usePlaylistGenres, } from "frontend/src/domain/playlists";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { PlaylistBusinessTypesCheckboxGroup } from "frontend/src/domain/playlist-business-type";
import { SelectPlaylistType } from "./select-client";
var useStyles = makeStyles({
    iconButton: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
    image: {
        position: "relative",
        height: 96,
        width: 96,
        flexShrink: 0,
        backgroundImage: function (_a) {
            var image = _a.image;
            return "url(" + image + ")";
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        "& .MuiButtonBase-root": {
            display: function (_a) {
                var image = _a.image;
                return (image ? "none" : "inline-block");
            },
        },
        "&:hover .MuiButtonBase-root": {
            display: "inline-block",
        },
    },
});
export var Form = function (_a) {
    var title = _a.title, entries = _a.entries, client = _a.client, published = _a.published, type = _a.type, businessTypes = _a.businessTypes, image = _a.image, handlers = _a.handlers;
    var classes = useStyles({
        image: image.value,
    });
    var ref = React.createRef();
    var duration = usePlaylistDuration(entries.tracks);
    var genres = usePlaylistGenres(entries.tracks);
    return (React.createElement("form", { onSubmit: handlers.submit.do },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Box, { display: "flex", alignItems: "flex-start" },
                React.createElement(Box, { flexGrow: 1 },
                    React.createElement(TextField, { label: "Название", value: title.value, error: !!title.error, helperText: title.error, onChange: title.onChange, fullWidth: true })),
                type.value === "public" && (React.createElement(Box, { ml: 2 },
                    React.createElement("input", { hidden: true, type: "file", accept: "image/*", ref: ref, onChange: image.onChange }),
                    React.createElement(Box, { component: Paper, className: classes.image },
                        React.createElement(IconButton, { className: classes.iconButton, onClick: function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click(); }, size: "small" },
                            React.createElement(Image, { htmlColor: "grey" })))))),
            React.createElement(Box, { mt: 1 },
                React.createElement(SelectPlaylistType, { client: client, type: type })),
            type.value === "public" && (React.createElement(Box, { mt: 1 },
                React.createElement(PlaylistBusinessTypesCheckboxGroup, { selectedIds: businessTypes.value, onChange: businessTypes.onChange }))),
            React.createElement(Box, { mt: 1, display: "flex", alignItems: "flex-end" },
                React.createElement(ButtonLoader, { variant: "contained", color: "primary", type: "submit", isLoading: handlers.submit.pending }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
                React.createElement(Box, { ml: "auto" },
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: published.value, onChange: published.onChange, name: "published", color: "primary" }), label: "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C" })))),
        React.createElement(Box, { mt: 1 },
            React.createElement(Accordion, null,
                React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                React.createElement(Box, { component: AccordionDetails, display: "flex", flexDirection: "column" },
                    React.createElement(Box, null,
                        React.createElement(Typography, { variant: "body2" }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C:"),
                        React.createElement(Typography, { variant: "h6", display: "inline" }, duration)),
                    React.createElement(Box, { mt: 1 },
                        React.createElement(Typography, { variant: "body2" }, "\u0412\u0441\u0435\u0433\u043E \u0442\u0440\u0435\u043A\u043E\u0432:"),
                        React.createElement(Typography, { variant: "h6", display: "inline" }, entries.tracks.length)),
                    React.createElement(Box, { mt: 1 },
                        React.createElement(Typography, { variant: "body2" },
                            "\u0416\u0430\u043D\u0440\u044B:",
                            React.createElement("br", null),
                            typeof genres === "object" &&
                                genres.map(function (genre) { return (React.createElement(Box, { display: "inline-block", mr: 1, mt: 1, component: "span", key: genre },
                                    React.createElement(Chip, { label: genre, component: "span" }))); })))))),
        React.createElement(Box, { mt: 1 },
            React.createElement(ReOrderPlaylistTracksTable, { entries: entries.value, onTrackMove: entries.reorder, onTrackRemove: entries.remove, onTrackPlay: handlers.play, onTrackPause: handlers.pause }))));
};
